import { render, staticRenderFns } from "./page-team.vue?vue&type=template&id=7304f508&"
import script from "./page-team.vue?vue&type=script&lang=js&"
export * from "./page-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports